import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { API } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    API.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(null));
  }, []);

  const login = useCallback(async (identifier, password) => {
    const r = await API.post("/auth/login", { identifier, password });
    setUser(r.data);
    return r.data;
  }, []);

  const logout = useCallback(async () => {
    try {
      await API.post("/auth/logout");
    } catch (e) { /* session deja close */ }
    setUser(null);
  }, []);

  const hasPerm = useCallback(
    (...perms) => {
      if (!user || !user.permissions) return false;
      if (user.permissions.includes("*")) return true;
      return perms.some((p) => user.permissions.includes(p));
    },
    [user]
  );

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, hasPerm }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
